module.exports = __webpack_public_path__ + "static/media/case3.9a5034f5.png";